export default __webpack_public_path__ + "media/images/lp/howto-pc-484daf176dab3c13d4e6ccb621c83636.jpg";